import {createSlice} from "@reduxjs/toolkit";

let initialState = {
    status: 1,
    rerender: false,
    organizationRedux: 0
}

const adversStatus = createSlice({
    name: "status",
    initialState,
    reducers: {
        toggleStatus(state, action){
            state.status = action.payload;
        },
        statusRerender(state){
            state.rerender = !state.rerender;
        },
        toggleAdsStatus(state, action){
            state.statusAds = action.payload;
        },
        toggleOrganization(state, action){
            state.organizationRedux = action.payload;
        }
    }
})

export default adversStatus;